<template>
  <div class="recordDetail">
    <Navbar :appTitle="$route.meta.title" @ClickRight="ClickRight" />
    <!--头部-->
    <div class="d-head">
      <div class="content">
        <div class="left">
          <div class="title">{{ detailInfo.entryCode }}</div>
          <div class="row">
            入库类型：<span class="highlight">{{ detailInfo.inWarehouseTypeName || "--" }}</span>
          </div>
          <div class="row">
            送入人：<span class="highlight">{{ detailInfo.sendPersionName || "--" }}</span>
          </div>
          <div class="row">
            入库时间：<span class="highlight">{{ detailInfo.inWarehouseTime || "--" }}</span>
          </div>
          <div class="row">
            关联工单：<span class="highlight">{{ detailInfo.produceOrderCode || "--" }}</span>
          </div>
        </div>
      </div>
    </div>
    <van-tabs v-model="active" :offset-top="158" line-width="150px" color="#1890FF">
      <van-tab title="入库物品明细">
        <div class="list" :style="{ height: '65vh' }" v-if="entryDetails.length">
          <div v-for="(item, index) in entryDetails" :key="index" class="wrap">
            <div class="top">
              <div class="icon"></div>
              <div class="title">{{ item.serialNumber }} | {{ item.serialName }}</div>
            </div>
            <div class="center">
              <p v-for="(value, key) in itemDetails(item)" :key="key">
                <span class="key">{{ key }}：</span>
                <span class="value">{{ value }}</span>
              </p>
            </div>
          </div>
        </div>
        <van-empty v-else description="入库物品明细为空" />
      </van-tab>

      <van-tab title="自定义信息">
        <div class="list" :style="{ height: '65vh' }" v-if="detailInfo.extDataJson && detailInfo.extDataJson.length">
          <div class="wrap">
            <div class="center">
              <p v-for="(item, index) in detailInfo.extDataJson" :key="index">
                <span class="key fontAno">{{ item.fieldName }}：</span>
                <span class="value fontAno">{{ item.fieldValue }}</span>
              </p>
            </div>
          </div>
        </div>
        <van-empty v-else description="自定义字段为空" />
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import Navbar from "@/components/navBar/navBar_right"
import pageList from "@/components/pageList"
import { inventoryOrderDetail, inventoryOrderDetailList, formTypeExtendedFieldList } from "@/api/mobile"
import store from "@/store"

export default {
  name: "inventoryOrderDetail",
  components: { Navbar, pageList },
  data() {
    return {
      active: 0,
      detailInfo: {},
      entryDetails: [],
      formTypeExtendedFields: [],
    }
  },
  created() {
    store.commit("SET_CURRENT_PREFIX", "/jksaas-produce/produce")
    this.getDetail()
  },
  methods: {
    async getDetail() {
      try {
        const formTypeRes = await formTypeExtendedFieldList({ formType: 5 })
        if (formTypeRes.code === 200 && formTypeRes.result) {
          this.formTypeExtendedFields = formTypeRes.result
        }

        const id = this.$route.query.id
        const detailRes = await inventoryOrderDetail({ id })
        if (detailRes.code === 200 && detailRes.result) {
          this.detailInfo = detailRes.result
          this.detailInfo.extDataJson = this.formTypeExtendedFields.map((ele) => ({
            ...ele,
            fieldValue: this.detailInfo.extDataJson[ele.fieldKey] || ele.fieldValue,
          }))
        } else {
          this.$toast(detailRes.message)
        }

        const listRes = await inventoryOrderDetailList({ entryId: id, inOutType: 0 })
        if (listRes.code === 200 && listRes.result) {
          this.entryDetails = listRes.result.records
        } else {
          this.$toast(listRes.message)
        }
      } catch (error) {
        this.$toast("获取详情失败")
      }
    },
    itemDetails(item) {
      return {
        规格: item.serialSpecifications || "-",
        单位: item.unitName || "-",
        数量: item.inWarehouseNum || "-",
      }
    },
    ClickRight() {
      this.$router.push({ path: "/application" })
    },
  },
}
</script>

<style lang="scss" scoped>
.recordDetail {
  height: 100vh;
  overflow: hidden;
  .d-head {
    width: 100%;
    padding: 32px;
    background: #ffffff;
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left {
        flex: 1;
        .title {
          font-size: 32px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #191f25;
          line-height: 32px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .row {
          font-size: 28px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #888888;
          margin-top: 20px;
        }
      }
    }
  }
  .highlight {
    color: #191f25;
  }
  .list {
    height: 65vh;
    overflow: scroll;
    .wrap {
      background: #fff;
      margin: 24px 0;
      padding: 30px;
      width: 100vw;
      .top {
        display: flex;
        justify-content: flex-start;
        .icon {
          width: 6px;
          height: 36px;
          background: #1890ff;
          margin-top: 6px;
          margin-right: 20px;
        }
        .title {
          width: 620px;
          margin-right: 20px;
          font-size: 32px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #191f25;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .center {
        p {
          margin: 16px 25px;
          font-size: 28px;
          display: flex;
          position: relative;
          .key {
            color: #888888;
          }
          .value {
            color: #191f25;
            width: 380px;
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .fontAno {
            font-size: 30px;
            padding-left: 20px;
          }
        }
      }
    }
  }
}
</style>
